module.exports = __webpack_public_path__ + "files/1c87ed7f46f3ac89e95bddf5208280d1.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/places-2.png
// module id = 1614
// module chunks = 60